module.exports = __webpack_public_path__ + "img/mooc_bg.94ba4cfe.jpg";